import { createContext, useContext, useState } from "react";

interface SearchContextType {
  activateSearch: () => void;
  deactivateSearch: () => void;
  isSearchActive: boolean;
}

const SearchContext = createContext<SearchContextType | undefined>(undefined);

export const SearchProvider = ({ children }: { children: React.ReactNode }) => {
  const [isSearchActive, setIsSearchActive] = useState(false);

  const activateSearch = () => {
    setIsSearchActive(true);
  };
  const deactivateSearch = () => {
    setIsSearchActive(false);
  };

  return (
    <SearchContext.Provider
      value={{ isSearchActive, activateSearch, deactivateSearch }}
    >
      {children}
    </SearchContext.Provider>
  );
};

export const useSearch = () => {
  const context = useContext(SearchContext);
  if (context === undefined) {
    throw new Error("useSearch must be used within a SearchProvider");
  }
  return context;
};
